export default {"src":"/_next/static/media/homepage-reviews-icon-desktop.5af29240.svg","height":52,"width":170,"blurWidth":0,"blurHeight":0};